export const normalizeExportResponse = responseData => {
  if (
    !responseData ||
    Array.isArray(responseData) ||
    !Array.isArray(responseData.stores) ||
    !Array.isArray(responseData.groups) ||
    !responseData.disabledFields ||
    Array.isArray(responseData.disabledFields) ||
    typeof responseData.disabledFields !== 'object'
  ) {
    throw new TypeError('Resposta de exportação inválida.')
  }

  return {
    stores: responseData.stores,
    groups: responseData.groups,
    disabledFields: responseData.disabledFields
  }
}
